import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Tracking-Links',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Soziale Medien',
  },
  form: {
    utm_source: {
      label: 'Quelle',
      placeholder: 'Quelle eingeben',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Andere soziale Medien',
        [CustomUtmSource.Other]: 'Andere',
      },
    },
    utm_source_details: {
      label: 'Benutzerdefinierte Quelle',
      placeholder: 'Quelle eingeben',
    },
    target_product: {
      label: 'Ziel',
      placeholder: 'Ziel auswählen',
    },
    target_url: {
      label: 'Ziel URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medium',
      placeholder: 'Medium eingeben',
    },
    utm_campaign: {
      label: 'Kampagne',
      placeholder: 'Kampagne eingeben',
    },
  },
  fields: {
    utm_source: 'Quelle',
    target_product: 'Ziel',
    type: 'Typ',
    utm_medium: 'Medium',
    utm_campaign: 'Kampagne',
    utm_referrer_id: 'Referrer-ID',
  },
  buttons: {
    create_auto_links: 'Automatische Links erstellen',
    create_link: 'Link erstellen',
    create: 'Erstellen',
    update: 'Update',
    copy_link: 'Link kopieren',
    download_qr_code: 'QR-Code herunterladen',
    edit: 'Bearbeiten',
  },
  modals: {
    auto_links_creation: {
      title: 'Sind Sie sicher?',
      description:
        'Vergewissern Sie sich, dass Sie die Shop-Konfiguration abgeschlossen haben (Subdomain des Online-Shops / Domain des Schaufensters), denn wenn Sie diese nach der Erstellung der Links ändern, werden die bestehenden Links nicht automatisch beeinflusst!',
    },
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    link_got_copied: 'Link wurde kopiert!',
    failed_to_download_qr_code: 'Herunterladen des QR-Codes fehlgeschlagen',
  },
};
